import { TemplateObjectType } from 'data/templates/api';

export interface ConditionalVariablesPluginConfiguration {
  renderer: (
    variableId: number,
    templateType: TemplateObjectType,
    container: HTMLElement,
  ) => void;
}

export const CK_VARIABLES_POPUP = 'ck-variables-popup';
export const CK_VARIABLES_TYPE_SELECT_POPUP = 'ck-variables-select-popup';
